import React from 'react';
import './SilentVideoBanner.scss';
import Text from '../../../../components/Text';
import Video from '../../../../components/Video';
import MaxWidthContainer from '../../../../components/MaxWidthContainer';

const SilentVideoBanner = ({
  title,
  isDesktopView,
  mobileVideoProps,
  desktopVideoProps,
}) => {
  const className = 'c-SilentVideoBanner';

  return (
    <MaxWidthContainer>
      <div className={className}>
        <div className={`${className}__hero`}>
          <div className={`${className}__video`}>
            {isDesktopView ? (
              <Video {...desktopVideoProps} />
            ) : (
              <Video {...mobileVideoProps} />
            )}
          </div>
          <div className={`${className}__img-overlay`}>
            <Text text={title} />
          </div>
        </div>
      </div>
    </MaxWidthContainer>
  );
};

export default SilentVideoBanner;
